export type ProfileTab = { key: string; label: string; permission?: string };

export const PROFILE_TABS: ProfileTab[] = [
  { key: 'overview', label: 'Overview' },
  { key: 'security', label: 'Security' },
];

export type ProfileOverviewForm = {
  firstName: string;
  lastName: string;
  email: string;
  countryCode: string;
  mobileNumber: string;
  fullAddress: string;
  locality: string;
  pincode: string;
  city: string;
  state: string;
  country: string;
};
